import { UndoRedo } from '@tiptap/extensions'

export type { UndoRedoOptions as HistoryOptions } from '@tiptap/extensions'
export { UndoRedo as History } from '@tiptap/extensions'

export default UndoRedo
